import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import CircularProgress from '@mui/material/CircularProgress'
import FormControl from '@mui/material/FormControl'
import IconButton from '@mui/material/IconButton'
import Input from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'
import InputLabel from '@mui/material/InputLabel'
import { Box } from '@mui/system'
import Table from 'common/components/Table'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { useContext, useMemo, useState } from 'react'
import InformesHelper from '../helpers/InformesHelper'
import { InformesContext } from '../providers/InformesProvider'

/**
 *
 * @param {Object} props
 * @param {InformeFilter} props.filter
 * @param {boolean} props.validating
 * @param {(newValue: any, pos: string) => void} props.changeFilter
 * @param {FiltersValuePosition} props.position
 * @param {boolean} props.disabled
 */
const FilterListOfValues = ({ filter, validating, changeFilter, position, disabled }) => {
  const [loading, setLoading] = useState(false)
  const Context = useContext(InformesContext)
  const [text, setText] = useState('')
  const { handleModal } = useContext(CustomModalContext)

  const value = useMemo(
    () => Context.active.filterData[`${filter.nombre_filtro}${position}`] ?? '',
    [Context?.active?.filterData, filter?.nombre_filtro, position],
  )

  const getLov = async () => {
    if (text) {
      setText('')
      changeFilter('', `${filter?.nombre_filtro}${position}`)
      return
    }
    setLoading(true)
    try {
      const response = await InformesHelper.getListOfValues(
        Context?.active?.current?.nombre_informe,
        filter?.lista_valores,
      )
      /** @type {CustomTableGridOptions[]} */
      const newStructure =
        response?.columnas?.map((item, index) => {
          return { key: item.etiqueta, value: `${item.tipo}${index + 1}`, flex: 1 }
        }) ?? []

      handleModal({
        type: ModalTypes.Custom,
        enabled: true,
        closable: true,
        content: (
          <Box
            sx={{
              px: 1,
              pt: 1,
              width: { xs: '100%', sm: '60vw' },
              minWidth: '60vw',
              backgroundColor: 'background.default',
              '& .MuiDataGrid-toolbarContainer > .MuiTextField-root': {
                width: '100%',
              },
              '& .MuiDataGrid-toolbarContainer > button': {
                display: 'none !important',
                backgroundColor: 'red !important',
              },
            }}
          >
            <>
              <Table
                showInternalSearch={true}
                dataSource={response?.registros ?? []}
                page={1}
                loading={false}
                rowsPerPage={12}
                variant="compact"
                onRowClick={({ row }) => {
                  const tipo_columna =
                    response?.columnas[parseInt(response?.columna_retorno) - 1].tipo
                  const newValue = row[`${tipo_columna}1`] ?? ''
                  const text = `${newValue} | ${row[`${tipo_columna}2`]}`
                  setText(text)
                  changeFilter(newValue, `${filter?.nombre_filtro}${position}`)
                  handleModal({ enabled: false })
                }}
                count={response?.registros?.length}
                fields={newStructure.map((item) => {
                  /**@type {TableField}**/
                  const newItem = { ...item }
                  newItem.field = item.value
                  newItem.title = item.key
                  return newItem
                })}
              />
              {
                // <CustomTable
                //   onClickEvent={({ row: dataRow }, _, __) => {
                //     const tipo_columna =
                //       response?.columnas[parseInt(response?.columna_retorno) - 1].tipo
                //     const newValue = dataRow[`${tipo_columna}1`] ?? ''
                //     const text = `${newValue} | ${dataRow[`${tipo_columna}2`]}` ?? ''
                //     setText(text)
                //     changeFilter(newValue, `${filter?.nombre_filtro}${position}`)
                //     handleModal({ enabled: false })
                //   }}
                //   showToolbar
                //   rowid="NUMERO_FILA"
                //   fields={newStructure}
                //   dataSource={response.registros}
                // />
              }
            </>
          </Box>
        ),
      })

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const error =
    filter.obligatorio === 'S' &&
    validating &&
    !Context.active.filterData[`${filter.nombre_filtro}${position}`]

  return (
    <>
      <FormControl variant="standard" error={error} fullWidth>
        <InputLabel>{`${filter.titulo_columna} ${
          position.length > 0 ? position.slice(1) : position
        }`}</InputLabel>
        <Input
          type="text"
          value={text}
          disabled={loading || disabled}
          onChange={() => {
            return
          }}
          error={error}
          endAdornment={
            <InputAdornment position="end">
              <IconButton aria-label="abrir lista de valores" onClick={getLov}>
                {loading ? (
                  <CircularProgress size={20} />
                ) : text ? (
                  <ClearIcon color={error ? 'error' : ''} />
                ) : (
                  <SearchIcon color={error ? 'error' : ''} />
                )}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </>
  )
}

export default FilterListOfValues
